module.exports = __webpack_public_path__ + "img/informasi-tambahan-active.12a9ed3b.svg";